





























import { Component, Vue } from 'vue-property-decorator';
import { ErrorWithResponse } from '@/models/error';
import { BusEvent } from '../models/bus';
import { bus } from '../bus';

export function showError(title: string, error: Error): void {
  bus.$emit(BusEvent.ERROR, title, error);
}

interface ErrorDetail {
  key: string;
  message: string;
}

@Component
export default class ErrorMessage extends Vue {
  public visible: boolean = false;
  public title: string | null = null;
  public detail: string | null = null;
  public detailItems: Map<string, string> | null = null;

  private counter: number = 0;

  public created() {
    this.$bus.$on(BusEvent.ERROR, this.show.bind(this));

    this.$bus.$on(BusEvent.CLEAR_ERROR, this.hide.bind(this));
  }

  private show(title: string, error: Error) {
    this.$set(this, 'title', title);
    this.extractErrorMessage(error);
    this.$set(this, 'visible', true);

    const expectedCounter = ++this.counter;
    const that = this;
    setTimeout(() => {
      if (that.counter === expectedCounter) {
        that.hide();
      }
    }, 8000);
  }

  private hide() {
    this.$set(this, 'visible', false);
    this.$set(this, 'title', null);
    this.$set(this, 'detail', null);
  }

  private extractErrorMessage(error: Error) {
    try {
      if ('response' in error) {
        const response = (error as ErrorWithResponse).response;
        if (response.data) {
          if (typeof response.data === 'string') {
            this.$set(this, 'detail', response.data);
            this.$set(this, 'detailItems', null);
          } else if (
            response.data instanceof Object &&
            'detail' in response.data &&
            (response.data as any).detail !== undefined &&
            typeof (response.data as any).detail === 'string'
          ) {
            this.$set(
              this,
              'detail',
              `${(response.data as any).detail} (${response.status}: ${
                response.statusText
              })`
            );
            this.$set(this, 'detailItems', null);
          } else {
            const items: ErrorDetail[] = [];
            for (const key of Object.keys(response.data)) {
              if (key in response.data) {
                items.push({
                  key,
                  message: response.data[key].join(', ')
                });
              }
            }

            this.$set(this, 'detail', null);
            this.$set(this, 'detailItems', items);
          }
        } else {
          this.$set(
            this,
            'detail',
            `${response.statusText} (${response.status})`
          );
          this.$set(this, 'detailItems', null);
        }
      } else if ('messageItems' in error) {
        const items: ErrorDetail[] = [];
        const detailError = error as {
          messageItems?: { key: string; message: string }[];
        };

        for (const message of detailError.messageItems) {
          items.push({ key: message.key, message: message.message });
        }

        this.$set(this, 'detail', null);
        this.$set(this, 'detailItems', items);
      } else {
        this.$set(this, 'detail', error.message);
        this.$set(this, 'detailItems', null);
      }
    } catch (e) {
      this.$set(this, 'detail', error.message);
      this.$set(this, 'detailItems', null);
    }
  }
}
